import moment from 'moment';

const isBlackFriday = () => {
  const startDate = moment('2025-11-24T00:00:00');
  const endDate = moment('2025-12-03T23:59:59');
  if (moment().isBetween(startDate, endDate)) return true;
  return false;
};

export default isBlackFriday;
